<template>
	<button class="btn-default" v-on="$listeners">
		<span>{{ $t('skip') }}</span>
	</button>
</template>

<script>
export default {
	name: 'BaseSkipButton',
};
</script>

<style lang="sass" scoped>
.btn-default
	min-width: 140px
</style>
